import { Form } from 'react-bootstrap';
import { useDispatch, useSelector } from 'react-redux';
import {
  setEditorComment,
  getEditorComment,
} from '@domains/orchestrator-pricing-committee/store/slices/domainOrchestratorPricingCommittee.slice';

export const EditorCommentInput = () => {
  const dispatch = useDispatch();
  const comment = useSelector(getEditorComment);

  const handleChange = (e: React.ChangeEvent<HTMLTextAreaElement>) => {
    dispatch(setEditorComment(e.target.value));
  };

  return (
    <Form.Control
      as="textarea"
      rows={3}
      data-testid="editor-comment-input"
      style={{ width: '200px' }}
      value={comment}
      onChange={handleChange}
    />
  );
};
